import BaseComponent from '@/components/base'
import { setAriaFlag } from '@/core/utils/a11y'

const selectors = {
  trigger: '[data-lightbox-trigger]',
  image: '[data-lightbox-image]',
  close: '[data-lightbox-close]'
}

export default class Lightbox extends BaseComponent {
  static TYPE = 'lightbox'

  image: HTMLImageElement
  closeButton: HTMLElement | undefined
  returnFocusEl: HTMLElement | null

  constructor(el: HTMLElement) {
    super(el)

    this.image = this.qs(selectors.image) as HTMLImageElement
    this.closeButton = this.qs(selectors.close)
    this.returnFocusEl = null

    this.onDocumentClick = this.onDocumentClick.bind(this)
    this.onKeydown = this.onKeydown.bind(this)

    // Triggers live outside this.el (gallery images) — delegate on the document
    document.addEventListener('click', this.onDocumentClick)
    document.addEventListener('keydown', this.onKeydown)

    this.el.addEventListener('click', () => this.close())
  }

  destroy() {
    document.removeEventListener('click', this.onDocumentClick)
    document.removeEventListener('keydown', this.onKeydown)

    if (!this.isAriaHidden) {
      document.body.style.overflow = ''
    }

    super.destroy()
  }

  open(src: string, alt: string = '') {
    this.image.src = src
    this.image.alt = alt

    setAriaFlag(this.el, 'aria-hidden', false)
    document.body.style.overflow = 'hidden'
    this.closeButton?.focus()
  }

  close() {
    setAriaFlag(this.el, 'aria-hidden', true)
    document.body.style.overflow = ''

    this.returnFocusEl?.focus()
    this.returnFocusEl = null
  }

  onDocumentClick(e: MouseEvent) {
    const trigger = (e.target as HTMLElement).closest(selectors.trigger) as HTMLElement | null

    if (!trigger || !trigger.dataset.lightboxSrc) return

    this.returnFocusEl = trigger
    this.open(trigger.dataset.lightboxSrc, trigger.querySelector('img')?.alt ?? '')
  }

  onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape' && !this.isAriaHidden) {
      this.close()
    }
  }
}
